import { LANGUAGES } from "@/i18n";

export const langInfo = (code) => LANGUAGES.find((l) => l.code === (code || "").toLowerCase()) || null;

export const langLabel = (code) => {
  const l = langInfo(code);
  return l ? l.label : (code ? code.toUpperCase() : "—");
};

// Flag emoji from the 2-letter country code (cc) attached to each language.
export const langFlag = (code) => {
  const l = langInfo(code);
  if (!l?.cc) return "🏳️";
  return l.cc.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
};
